
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import CompanyFollowUpRecordForm from "../../CompanyFollowUpRecord/CompanyFollowUpRecordForm.vue";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";
import MiezzForm from "@/models/MiezzForm";
import DtoFormCompanyFollowUpRecord from "@/models.machine/DtoFormCompanyFollowUpRecord";
@Options({
  components: {
    CompanyFollowUpRecordForm,
  },
})
export default class SupplierCompanyFollowUpRecordEdit extends Vue {
  type = EnumCompanyType.Supplier;
  form = new MiezzForm<DtoFormCompanyFollowUpRecord, string>(
    "SupplierManagement_FollowUpRecord_Edit"
  );
}
